import { Component, Input, ViewEncapsulation } from '@angular/core';
import { isEmpty } from 'lodash-es';

export interface MainToolbarHeaderInfoItem {
    label: string;
    value: string;
}

export interface MainToolbarHeaderInfo {
    mainDescription: string;
    secondaryDescription: string;
    infoList: MainToolbarHeaderInfoItem[];
}

@Component({
    selector: 'se-header-info',
    templateUrl: './se-header-info.component.html',
    styleUrls: ['./se-header-info.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SeHeaderInfoComponent {
    @Input() info: MainToolbarHeaderInfo;

    get isInfoEmpty():boolean {
        return !this.info || !this.info.infoList || this.info.infoList.length == 0;
    }

    get isMultilineButton(): boolean {
        return this.info && !isEmpty(this.info.secondaryDescription);
    }
}
